import { MedicalDocumentationCreateFormBean } from './MedicalDocumentationCreateForm.types';

export const getFormInitialValues = (): MedicalDocumentationCreateFormBean => ({
   periodRange: 'ENTIRE_PERIOD',
   dateTo: undefined,
   dateFrom: undefined,
   includeConfidentialAnnotation: false,
});
